import * as types from "@/store/types";
import axios from "axios";

export default {
  saveToken({ commit }, token) {
    commit(types.SAVE_TOKEN, token);
  },
  async listAnswers({ commit }) {
    try {
      const { data } = await axios.get("/api/web/user/answers");
      commit(types.LIST_ANSWERS, { answers: data });
      return data;
    } catch (e) {
      return null;
    }
  },
  async showAnswersUsers({ commit }, id) {
    try {
      const { data } = await axios.get(`/api/web/user/${id}/answers`);
      commit(types.FECTH_ANSWERS, { answers_user: data });
      return data;
    } catch (e) {
      return null;
    }
  }
};
